const BlastName=[
  "NLU",
    "NNU"
  ]
 export default BlastName